import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getAgentPromptTesterConfig = unaryRpc({
  name: "getAgentPromptTesterConfig",
  input: z.object({}),
  output: z.object({
    agents: z.array(
      z.object({
        name: z.string(),
        templateVariables: z.array(z.string()).optional(),
      }),
    ),
  }),
});
